<template>
	<div>
		<div v-show="calculatorPending && !developersReady">
			<p class="text">Загрузка...</p>
		</div>
		<div v-show="!calculatorPending && !calculatorReady">
			<notice content="<p class='p1'><strong>Проводятся плановые работы</strong></p><p class='p1 _mt-16'>На период проведения работ ипотечный калькулятор и подача заявки через личный кабинет недоступны.</p><p class='p1 _mt-16'>Приносим извинения за доставленные неудобства. Команда Банка ДОМ.РФ.</p>" bg-color="gray"></notice>
		</div>
		<section class="mortgage_new" id="mortgage-calc" v-show="(!calculatorPending && calculatorReady) || developersReady">
			<div id="mortgage-calcnew" class="mortgage-calcnew" ref="mainPart">
				<div class="mortgage-calcnew__body">
					<div class="mortgage-calcnew__left">
						<!--Developers landing code -->
						<div v-if="developersFlag && developersDi">
							<div class="mortgage-calcnew_part">Регион</div>
							<mortgage-developers-region :regions="regionsList" classname="_mb-12" v-on:getRegionCode="getDevelopersRegion($event)"></mortgage-developers-region>
							<div class="mortgage-calcnew_part">Наименование застройщика</div>
							<mortgage-developers-search classname="_mb-12" v-on:getDevelopersSource="getDevelopersSource($event)"></mortgage-developers-search>
						</div>
						<!--End developers landing code -->
						<h2 class="h2">Калькулятор ипотеки</h2>
						<div class="mortgage-calcnew__goal _pt-40" :class="{'hidden': hiddenFields.includes('goals')}" v-if="!developersFlag">Цель кредита</div>
						<mortgage-calculator-tabs :disabled-combinations="disabledCombination" :class="{'hidden': hiddenFields.includes('tabs')}" v-if="!developersFlag" v-on:setTabActive="setActive($event, 'mortgage-tabs')" />
						<mortgage-calculator-goalmobile :combinations="mobileCombination" :class="{'hidden': hiddenFields.includes('tabs')}" v-on:setTabActive="setActive($event, 'mortgage-tabs')" v-if="!developersFlag" />
						<div class="mortgage-calcnew__parameters" v-if="!developersFlag">
							<div class="mortgage-calcnew__goalsel" :class="{'hidden': hiddenFields.includes('realty')}" ref="goalsel">
								<d-select
									v-model="realty"
									:items="realtyItems"
									:wide="true"
									label="Недвижимость"
									id="tip"
								/>
							</div>

							<div ref="regionsel">
								<d-select
									v-model="currentRegion"
									:items="regionsList"
									id="region"
								/>
							</div>
							<p class="mortgage-send__minitext _mt-8"> Регион приобретения недвижимости</p>
						</div>
						<div class="mortgage-calcnew__slider" v-show="(sliderShow && !developersFlag)" :class="{'hidden': hiddenFields.includes('slider')}">
							<mortgage-calculator-slider :targets="targetsCode" :products="slidesProducts" :slidesText="slidesText" :information="slidesInformation" v-on:sliderText="sliderText($event)" v-if="program !== 'it_specialist'"></mortgage-calculator-slider>
						</div>
						<div class="mortgage-calcnew__slider" v-if="realty === 'pledged'">
							<div class="mortgage-calcnew__slides-text">Купите готовую квартиру или апартаменты, которые находятся в&nbsp;залоге у&nbsp;стороннего банка </div>
						</div>
						<div class="mortgage-calcnew__inputs">
							<div class="mortgage-calcnew_mt25" v-show="targetsCode === 'it_specialist'">
								<div class="mortgage-calcnew_part">ИНН организации</div>
								<div class="noUi noui_pb">
								<vue-suggestion
									name="innIt"
									id="innIt"
									v-model="innIt"
									label="ИНН организации"
									method="party"
									@select="suggestionOptions.onSelect($event, 'it_specialist')"
								>
								</vue-suggestion>
								<p class="form-error" v-if="innChecker === 'failure'">Для сотрудников вашей организации условия программы недоступны</p>
								<p class="text-small green-text _mt-8" v-if="innChecker === 'success'">Организация соответствует требованиям программы</p>
								</div>
							</div>
							<div class="mortgage-calcnew_mt25" v-show="targetsCode === 'it_specialist'">
								<div class="mortgage-calcnew_part">Город работодателя</div>
								<d-select
									v-model="itRegion"
									:items="regionsIt"
								/>
								<p class="mortgage-send__minitext _mt-8">Выберите город по юридическому адресу организации</p>
							</div>
							<div class="mortgage-calcnew_mt25" v-show="targetsCode === 'it_specialist'">
								<div class="mortgage-calcnew_part">Доход</div>
								<div class="noUi noui_pb">
									<div class="noUi__input noUi__input_nozi noui__input_hide-border" :class="{'mortgage-partner__field_error': itIncomeError}">
										<input
										type="text"
										v-model="itIncome"
										inputmode="numeric"
										v-mask-numeric
										v-money
										pattern="\d*"
										class="noUi__text p2"
										ref="itInput">
										<div ref="itIncome"></div>
									</div>
								</div>
								<p class="form-error" v-show="itIncomeError">Минимальный доход для выбранного города {{ itIncomeMin | formatWithDelimeters }} </p>
							</div>

							<div class="mortgage-calcnew_mt25">
								<div class="mortgage-calcnew_part">Стоимость <span v-show="activeMortgageTabs === 'pledge'">имеющейся</span> недвижимости</div>
								<div class="noUi noui_pb">
									<div class="noUi__input noUi__input_nozi  noui__input_hide-border">
										<input
										type="text"
										v-model="realtyPrice"
										inputmode="numeric"
										v-mask-numeric
										v-money
										pattern="\d*"
										class="noUi__text p2"
										ref="realtyInput">
										<div ref="mortgagePrice"></div>
									</div>
										<span class="showCalculatorPrice noUi__start p2 mortgage-calcnew__flspans">{{stgMin | numFormat('0,0 a')}} </span>
										<span class="showCalculatorPrice noUi__end p2 mortgage-calcnew__flspans">{{stgMax | numFormat('0,0 a')}}  </span>
								</div>
							</div>

							<div class="mortgage-calcnew_mt25" v-show="loanAmountShow">
								<div class="mortgage-calcnew_part"><span v-show="activeMortgageTabs === 'pledge'">Сумма кредита</span><span v-show="activeMortgageTabs === 'refin'">Остаток долга</span></div>
								<div class="noUi noui_pb">
									<div class="noUi__input noUi__input_nozi  noui__input_hide-border">
										<input
										type="text"
										v-model="loanAmount"
										inputmode="numeric"
										v-mask-numeric
										pattern="\d*"
										v-money
										class="noUi__text p2"
										ref="loanInput">
										<div ref="mortgageLoan"></div>
									</div>
									<span class="showCalculatorLoan noUi__start p2 mortgage-calcnew__flspans">{{pledgeMin | numFormat('0,0 a')}} </span>
									<span class="showCalculatorLoan noUi__end p2 mortgage-calcnew__flspans" v-show="activeMortgageTabs !== 'pledge'">{{refinMax | numFormat('0,0 a')}} </span>
									<span class="showCalculatorLoan noUi__end p2 mortgage-calcnew__flspans" v-show="activeMortgageTabs === 'pledge'">{{pledgeMaxRealty | numFormat('0,0 a')}} </span>
								</div>
							</div>

							<div class="mortgage-calcnew_mt25" v-show="pledgeShow">
								<div class="mortgage-calcnew_part">Первоначальный взнос</div>
								<div class="noUi noui_pb">
									<div class="noUi__input noUi__input_nozi noui__input_hide-border">
										<input
										type="text"
										v-model="pledge"
										inputmode="numeric"
										v-mask-numeric
										pattern="\d*"
										v-money
										:disabled="matcap"
										class="noUi__text p2"
										ref="pledgeInput">
										<div class="range-input-mortgage__perv">{{prvPercent}}%</div>
										<div ref="mortgagePledge" :disabled="matcap"></div>
									</div>
										<span class="showCalculatorPledge noUi__start p2 mortgage-calcnew__flspans">{{pledgeMin | numFormat('0,0 a')}}</span>
										<span class="showCalculatorPledge noUi__end p2 mortgage-calcnew__flspans">{{pledgeMax | numFormat('0,0 a')}}</span>
								</div>
							</div>
							<div class="mortgage-calcnew__matcapital mortgage-calcnew_mt25" v-show="targetsCode === 'product_building' || targetsCode === 'product_ready' || targetsCode === 'product_countryside'">
								<div>Использовать материнский капитал</div>
								<div>
									<div class="dr-checkbox">
										<div class="checkbox">
											<input
											v-model="matcap"
											type="checkbox"
											class="checkbox__input"
											id="checkbox__label1">
											<label for="checkbox__label1" class="checkbox__label"></label>
										</div>
									</div>
								</div>
								<p class="mortgage-calcnew_mt25" v-show="targetSlide === 'product_countryside'">Для индивидуальных предпринимателей и собственников бизнеса минимальный размер первоначального взноса составляет 35%. </p>
								<div v-show="matcap" class="mortgage-calcnew__matcapital mortgage-calcnew__matcapital_fields">
									<div class="noUi noui_pb mortgage-calcnew_mt25 mortgage-calcnew__matcapital_field">
										<div class="mortgage-calcnew_part">Материнский капитал</div>
										<div class="noUi__input noUi__input_nozi  noui__input_hide-border">
											<input
											type="text"
											v-model="maternalCapital"
											v-mask-numeric
											v-money
											class="noUi__text p2"
											ref="matcapInput">
											<div ref="mortgageMatcap"></div>
										</div>
									</div>
									<div class="noUi noui_pb mortgage-calcnew_mt25 mortgage-calcnew__matcapital_field">
										<div class="mortgage-calcnew_part">Личные средства</div>
										<div class="noUi__input noUi__input_nozi  noui__input_hide-border">
											<input
											type="text"
											v-model="money"
											v-mask-numeric
											v-money
											class="noUi__text p2"
											ref="moneyInput">
											<div ref="mortgageMoney"></div>
										</div>
									</div>
								</div>
							</div>

							<!--Developers landing code -->
							<div v-if="developersFlag">
								<mortgage-developers-slider :options="activeCodes" v-on:getDevProgram="getDevelopersSlider($event)" v-on:getFamilyData="getDevelopersChildren($event)" :dfoshow="developersDfoShow" />
							</div>
							<!--End developers landing code -->

							<div class="mortgage-calcnew_mt25" v-show="periodShow">
								<div class="mortgage-calcnew_part"><span v-show="activeMortgageTabs !== 'refin'">Срок кредита</span><span v-show="activeMortgageTabs === 'refin'">Оставшийся срок кредита </span></div>
								<div class="noUi noui_pb">
									<div class="noUi__input noUi__input_nozi  noui__input_hide-border">
										<input
										type="text"
										v-model="period"
										inputmode="numeric"
										v-mask-numeric
										v-period
										pattern="\d*"
										class="noUi__text p2"
										ref="periodInput">
										<div ref="mortgagePeriod"></div>
									</div>
										<span  class="showCalculatorPeriod noUi__start p2 mortgage-calcnew__flspans">{{periodMin | periodString}}</span>
										<span  class="showCalculatorPeriod noUi__end p2 mortgage-calcnew__flspans">{{periodMax | periodString}}</span>
								</div>
							</div>
						</div>
						<div class="mortgage-calcnew__options">
							<div class="mortgage-calcnew__dop" v-if="!developersFlag">Дополнительные опции</div>
							<div class="mortgage-calcnew__dop_min _mt-12 _mb-16">Возможен выбор нескольких</div>
							<div class="mortgage-calcnew__buttons" v-if="!developersFlag">
								<button class="button button_size-sm mortgage-calcnew__b-all"
								:class="{moptions_active: isActive('all')}"
								@click.prevent="setActive('all', 'options')">Все</button>
								<button class="button button_size-sm mortgage-calcnew__b-reduction"
								:class="{moptions_active: isActive('rate')}"
								@click.prevent="setActive('rate', 'options')" ref="rateOptions">Снижение&nbsp;ставки</button>
								<button class="button button_size-sm mortgage-calcnew__b-special"
								:class="{moptions_active: isActive('action')}"
								@click.prevent="setActive('action', 'options')" ref="actionOptions">Спецпредложение</button>
							</div>
						</div>
						<div class="mortgage-calcnew__cards" ref="cards" :class="optionsHeight">
							<div class="mortgage-calcnew__cards-wrapper">
								<div class="mortgage-calcnew__card"
								v-for="(option, index) in parseOptions(targetOptions)"
								:key="index"
								:data-code="option.code"
								:class="{'hidden': (hiddenOptions.indexOf(option.code) !== -1) || (option.code === 'far_east_family' && !developersDfoRegions.includes(currentRegion))
								|| (option.code === 'parking' && !developersFlag) || (option.code === 'tech_option_d' && !developersFlag)}"
								@click.prevent="getTrueOptions(option.code)">
									<div class="mortgage-calcnew__card-wrapper">
									<div class="mortgage-calcnew__settings" v-show="option.code === 'maternal_capital'"></div>
									<div class="mortgage-calcnew__checkbox">
										<div class="dr-checkbox">
											<div class="checkbox">
												<input
												v-model="optcheck[option.code]"
												:data-code="option.code"
												type="checkbox"
												class="checkbox__input"
												:id="'checkbox__label_option-'+option.code">
												<label :for="'checkbox__label_option-'+option.code" class="checkbox__label"></label>
											</div>
										</div>
									</div>
									<div class="mortgage-calcnew__card-title" v-html="option.name"></div>
									</div>
									<div class="mortgage-calcnew__card-description">{{option.comment}}</div>
								</div>
							</div>
						<p class="form__note"></p>
						</div>
							<div class="mortgage-calcnew__show">
							<button v-show="optionsCounter > 4"
							class="button mortgage-calcnew__b-show"
							@click="bshowToggle">
							{{bshow}}</button>
						</div>
					</div>
				<div class="mortgage-calcnew__right">
					<div class="_sticky">
						<div class="mortgage-calcnew__flip">
							<mortgage-calculator-results
							:mobile="false"
								:resultsdata="{targets: targets, targetsCode: targetsCode, activeCodes: activeCodes, monthlyPay: monthlyPay, rbBeforePay: rbBeforePay, rate: rate, loanAmount: loanAmount, period: period,
									realtyPrice: realtyPrice, prvPercent: prvPercent, pledgeMaxPrv: pledgeMaxPrv, pledge: pledge, amountMaxRegion: amountMaxRegion, income: income, developersFlag: developersFlag, itIncomeError: itIncomeError }"
								:lk-redirect="lkRedirect" v-on:showPfrModal="showPfrModal" :auth="auth"
								:family-range='familyRange'
								:pref-range='prefRange'
								:building-range='buildingRange'
								:ready-range='readyRange'
								:it-range="itRange"
								:refin-range="refinRange"
								:house-range="houseRange"
								:east-range="eastRange"
							/>
						</div>
						<div class="mortgage-calcnew__calcblock mortgage-calcnew__calcblock_green mortgage-calcnew__calcblock_withpd _mt-32" v-if="developersFlag && !activeCodes.includes('easy_mortgage') && activeCodes.filter(val=>val.indexOf('salary') !== -1).length === 0">
							<mortgage-calculator-pfr v-on:showPfrModal="showPfrModal"></mortgage-calculator-pfr>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mortgage-calcnew__flip _mobile-only">
			<div class="mortgage-calcnew__mobile_wrapper _front-side">
				<mortgage-calculator-results
					:mobile="true"
					:resultsdata="{targets: targets, targetsCode: targetsCode, activeCodes: activeCodes, monthlyPay: monthlyPay, rbBeforePay: rbBeforePay, rate: rate, loanAmount: loanAmount, period: period,
						realtyPrice: realtyPrice, prvPercent: prvPercent, pledgeMaxPrv: pledgeMaxPrv, pledge: pledge, amountMaxRegion: amountMaxRegion, income: income, developersFlag: developersFlag, itIncomeError: itIncomeError }"
					:lk-redirect="lkRedirect"
					v-on:showPfrModal="showPfrModal"
					:auth="auth"
					:family-range='familyRange'
					:pref-range='prefRange'
					:building-range='buildingRange'
					:ready-range='readyRange'
					:it-range="itRange"
					:refin-range="refinRange"
					:house-range="houseRange"
					:east-range="eastRange"
				/>
			</div>
			<div class="mortgage-calcnew__calcblock mortgage-calcnew__calcblock_green mortgage-calcnew__calcblock_withpd _mt-32" v-if="developersFlag && !activeCodes.includes('easy_mortgage') && activeCodes.filter(val=>val.indexOf('salary') !== -1).length === 0">
				<mortgage-calculator-pfr v-on:showPfrModal="showPfrModal"></mortgage-calculator-pfr>
			</div>
		</div>

			<d-modal
				v-cloak
				name="med"
				size="wide"
				:section-title="targets"
				:no-scroll="true"
				popup-title="Программа для медицинских работников"
			>
			<p class="p2">Пожалуйста, укажите ИНН или наименование организации, в которой вы работаете, чтобы узнать возможность применения данной опции. </p>
				<div class="inn-wrapper">
					<div class="noUi noui_pb">
						<vue-suggestion
							name="inn"
							id="inn"
							v-model="inn"
							method="party"
							label="ИНН"
							@select="suggestionOptions.onSelect($event)"
						>
						</vue-suggestion>
					</div>
				</div>
				<button class="inn-submit" @click.prevent="checkOkved">Проверить</button>
				<div class="inn-success _mt-16" v-show="okvedChecker === 'success'">
						<div class="inn-special-wrapper">
							<div class="inn-special-icon__yes"></div>
							<div class="inn-special-text">Для сотрудников вашей организации действуют специальные условия</div>
						</div>
						<button class="inn-get" @click="getOkvedDeduction">Применить</button>
				</div>
				<div class="inn-failure _mt-16" v-show="okvedChecker === 'failure'">
						<div class="inn-special-wrapper">
							<div class="inn-special-icon__no"></div>
							<div class="inn-special-text">Для сотрудников вашей организации специальные условия недоступны</div>
						</div>
				</div>
			</d-modal>

			<d-modal
				v-cloak
				name="pfrModal"
				size="wide"
				class="mortgage-lk"
				:no-scroll="true"
				popup-title="Подтверждение занятости и дохода выпиской из Фонда пенсионного и социального страхования Российской Федерации - это выгодно и удобно"
			>
				<p>Для оформления кредита не требуется предоставлять документы, подтверждающие доход и занятость, например, справку о доходах, трудовую книжку и пр. Достаточно предоставить согласие на получение Банком выписки из СФР, иметь официальный доход с отчислениями в СФР и подтвержденную учетную запись на Госуслугах.<p>
				<p class="_mt-12">Банк самостоятельно запросит выписку из фонда, клиенту потребуется только подтвердить свое согласие через СМС.</p>
				<button class="button button_black _mt-32" @click="closePfrModal">Закрыть </button>
			</d-modal>
		</section>
		<mortgage-calculator-payments :calculator-data="{ targets:targets, rate:rate, period:period, loanAmount:loanAmount, monthlyPay: monthlyPay }" />
		<!--Developers landing code -->
		<div v-if="developersFlag">
			<developers-form v-on:callServiceError="getDevelopersError($event)" :url="landingUrl" :family="devFamilyChecker" :dfoactive="developersDfoActive" :children-option="childrenOption" :children="developersChildren" :region="developersRegion" :source="developersSource"></developers-form>
		</div>
		<!--End developers landing code -->
	</div>
</template>

<script>
	import noUiSlider from 'nouislider';
	import axios from 'axios';
	import filters from '../../assets/js/vue/filters';
	import lkStore from '../../assets/js/scripts/lkStore.js';
	import { getQueryParameterByName } from '../../assets/js/utils';
	import defaults from './calculator/defaults.json';
	import dayjs from 'dayjs'
	import MortgageCalculatorTabs from './calculator/MortgageCalculatorTabs.vue';
	import MortgageCalculatorPayments from './MortgageCalculatorPayments.vue';
	import MortgageCalculatorGoalmobile from './calculator/MortgageCalculatorGoalmobile.vue';
	import MortgageCalculatorSlider from './calculator/MortgageCalculatorSlider.vue';
	import MortgageCalculatorResults from './calculator/MortgageCalculatorResults.vue';

	const clone = (target) => JSON.parse(JSON.stringify(target));

	export default {
		name: "MortgageCalculator",
		props: {
			partner: {
				type: String
			},
			developers: {
				type: String,
				default: ''
			},
			izs: {
				type: String,
				default: ''
			},
			lkRedirect: {
				type: String,
				default: "",
			},
			landingUrl: {
				type: String,
				default: "",
			},
			program: {
				type: String,
				default: "",
			},
			auth: {
				type: Boolean,
				default: false,
			},
			familyRange: {
				type: String,
				default: "",
			},
			prefRange: {
				type: String,
				default: "",
			},
			buildingRange: {
				type: String,
				default: "",
			},
			readyRange: {
				type: String,
				default: "",
			},
			itRange: {
				type: String,
				default: "",
			},
			refinRange: {
				type: String,
				default: "",
			},
			houseRange: {
				type: String,
				default: "",
			},
			eastRange: {
				type: String,
				default: "",
			}
		},
		components: {
			MortgageCalculatorTabs,
			MortgageCalculatorGoalmobile,
			MortgageCalculatorSlider,
			MortgageCalculatorResults,
			MortgageCalculatorPayments,
		},
		data() {
			return {
				...clone(defaults),
				filters: filters,
				calculatorReady: false,
				calculatorPending: false,
				targets: 'Квартира в новостройке', // Цель кредита
				purposeLk: 'buying', // Параметр цели кредита для ЛК
				realtyType: 'flat', // Параметр типа недвижимости для ЛК
				readiness: 'construction',
				targetsCode: '', // Служебная переменная для отслеживания текущего кода продукта
				currentRegion: '77', // Регион
				activeTabs: 'bycost', // Модель для табов "по стоимости" и "по доходу"
				activeMortgageTabs: 'buy', // Модель для табов: "Покупка", "Рефинансирование" и "Под залог"
				activeOptionsTabs: 'all', // Модель табов для выбора дополнительных опций
				slidesProducts: [], // Продукты для слайдера
				slidesCount: 0, // Служебная переменная для слайдера
				slidesText: '', // Появляющийся текст при нажатии на блоки слайдера
				targetSlide: '', // Показываемый слайд - нужен для связки с целью кредита
				bshow: 'Показать все', // Текст для кнопки скрытия или показа дополнительных опций
				bshowFlag: false, // Показывать или скрыть дополнительные опции
				step: 1000, // Шаг для range инпутов
				realtyPrice: 5000000, // Стоимость недвижимости
				pledge: 1500000, // Первоначальный взнос
				period: 15, // Срок кредита
				rate: 0, // Ставка
				kz: 0, // Значение параметра "Кредит-залог"
				rateSecond: 0, // Ставка - ставка ниже
				loanAmount: 0, // Сумма кредита
				monthlyPay: 0, // Ежемесячный платеж
				monthlyPaySecond: 0, // Ежемесячный платеж - ставка ниже
				income: 0, // Необходимый доход
				years: ['год', 'года', 'лет'], // Служебная переменная для простановки значения срока
				productsList: {}, // Сформированный из АПИКСа объект с продуктами
				targetOptions: {}, // Продукт для дополнительных опций
				targetOptionsOld: {}, // Служебная переменная для удобства переключения опций в зависимости от табов
				targetOptionsFirst: {}, // Служебная переменная - первоначальный снимок опций
				targetOptionsPrevious: {}, // Служебная переменная для перерисовки списка опций при снятии флага активности с элемента
				optionsCodes: [], // Служебная переменная для правильного взаимодействия между активными опциями
				activeCodes: [], // Служебная переменная для отслеживания активных опций
				optionsCounter: 0, // Счетчик опций
				stgMin: 625000, // Минимальное значение поля стоимости
				stgMax: 55000000, // Максимальное значение поля стоимости
				pledgeMin: 0, // Минимальный первоначальный взнос
				pledgeMax: 2, // Максимальное значение первоначального взноса
				pledgeMinPrv: 0, // Минимальный первоначальный взнос в процентах
				pledgeMaxPrv: 100, // Максимальный первоначальный взнос в процентах
				periodMin: 3, // Минимальный срок кредита
				periodMax: 30, // Максимальное значение срока кредита
				monthlyMin: 10000, // Минимальный месячный доход
				monthlyMax: 500000, // Максимальный месячный доход
				amountMin: 625000, // Сумма кредита минимальная
				amountMax: 20000000, // Сумма кредита максимальная
				amountMiddle: 10000000, // Значение по середине (Сумма кредита)
				amountMaxRegion: 0, // Максимальная сумма кредита для региона
				pledgeMaxRealty: 1, // Максимальное значение поля "Сумма кредита" в слайдере под залог
				products: {}, // Актуальный в данный момент продукт
				prvPercent: 0, // Первоначальный взнос для показа в инпуте
				realtySlider: '', // Слайдер "Стоимость недвижимости"
				pledgeSlider: '', // Слайдер "Первоначальный взнос"
				periodSlider: '', // Слайдер "Срок кредита"
				matCapSlider: '', // Слайдер "Материнский капитал"
				loanValueSliderId: 'mortgage-calc__stg-slider-byprvsumm', // Id для ползунка "Срок кредита"
				maternalCapital: 466617, // Размер материнского капитала
				maternalCapitalChecker: false, // Служебная переменная для валидации материнского капитала
				maternalCapitalError: false, // Служебная переменная для валидации материнского капитала
				realtyAmount: 0, // Стоимость недвижимости
				borrowermin: '', // Минимальный допустимый возраст заёмщика
				borrowermax: '', // Максимальный допустимый возраст заёмщика
				visibleCombination: ['preferential_house', 'preferential_house_land'], // Массив, чтобы скрывать неправильные комбинации продуктов
				disabledCombination: [], // Массив, чтобы дисейблить неправильные комбинации продуктов
				mobileCombination: [],
				inn: '', // Модель ИНН
				okved: '', // ОКВЕД, получаемый из дадаты - для медицинской ипотеки
				okvedChecker: '', // Для показа уведомления об успешной проверки либо наоборот
				okveds: ['86','86.1', '86.10', '86.2', '86.21', '86.22', '86.23', ' 86.9', '86.90', '86.90.1', '86.90.2', '86.90.4', '86.90.9'], // Коды ОКВЕД для медицинской ипотеки
				okvedsAll: [], // Все окведы по организации
				rateDeduction: 0, // Вычет для опций (получаем из АПИКС)
				apix: null, // Общий массив, получаемый из АПИКС
				costSwitcher: false,
				currency: null,
				optcheck: [],
				regionsList: [{'const': '77', title: 'Москва'}],
				matcapMin: 10000,
				matcapMax: 617000,
				region: '',
				matcap: false,
				money: 0,
				moneyMin: 0,
				rebates: [],
				realty: '',
				buttonSendText: 'Подать заявку',
				medNoCompatibility: ['product_far_east', 'product_far_east_house'],
				medSlidesCompatibility: ['product_family', 'product_preferential', 'product_countryside'],
				developersFlag: false,
				hiddenOptions: [],
				devFamilyChecker: false, // Developers landing only
				developersChildren: [], // Developers landing only
				developersDi: false, // Developers landing only
				developersRegion: '', // Developers landing only
				developersSource: '', // Developers landing only
				refinMax: 1,
				developersDfoShow: false, // Developers landing only
				developersDfoActive: false, // Developers landing only
				developersDfoRegions: ['25', '03', '28', '79', '75', '41', '49', '14', '65', '27', '87'],  // Developers landing only
				regionsUrl: '/rest/v2/network/regions',
				hiddenFields: [], // Для скрытых полей (на находящихся в DOM)
				rbBeforePay: 0, // Ежемесячный платеж до ставки ниже
				itRegion: 'Москва', // Только для IT-ипотеки
				itIncome: 150000, // Только для IT-ипотеки
				itIncomeMin: 150000, // Только для IT-ипотеки
				itIncomeError: false, // Только для IT-ипотеки
				innIt: '', // Только для IT-ипотеки
				innNumberIt: '', // Только для IT-ипотеки
				innRoute: '/rest/v1/mortgage/accreditedItCompany/', // Только для IT-ипотеки
				innChecker: '', // Только для IT-ипотеки
				bigsumDeduction: -0.2,
				bigsumPrograms: ['product_building', 'product_ready', 'product_building_house', 'product_secured_loan'],
				bigSumRegions: ['77', '50', '78', '47'],
				childrenOption: false,
				developersReady: false,
				suggestionOptions: {
					onSelect: (suggestion, flag) => {
						if (flag === 'it_specialist') {
							this.innNumberIt = suggestion.data.inn;
							this.checkItInn();
						}
						else {
							this.okvedsAll = suggestion.data.okveds;
						}

						this.okved = suggestion.data.okved ? suggestion.data.okved : '';
						this.inn = suggestion.data.inn ? suggestion.data.inn : '';
					}
				}
			}
		},
		methods: {
			showPfrModal() {
				this.$modal.show('pfrModal');
			},
			closePfrModal() {
				this.$modal.hide('pfrModal');
			},
			getDevelopersError(flag) {
				this.developersReady = flag ? false : true;
			},
			getActualProducts() {
				for (var prop in this.apix) {
					if (this.productsActual.indexOf(this.apix[prop].id) !== -1) {
						this.productsList[this.apix[prop].id] = this.apix[prop].attributes;
					}
				}
			},
			getApixValues(val) {
				if (this.productsList[val]) {
					this.targetOptions = JSON.parse(JSON.stringify(this.productsList[val].options));
					[this.targets, this.targetsCode] = [this.productsList[val].name, val];
					this.products = JSON.parse(JSON.stringify(this.productsList[val].product));
					// 3823 Kostyl
					if (this.realty === 'product_house' && this.targetsCode === 'product_preferential' || this.realty === 'product_building_house' && this.targetsCode === 'product_preferential') {
						this.targetOptions = this.targetOptions.filter(val => val.code === 'pfr_preferential' || val.code === 'salary_preferential' || val.code === 'easy_mortgage' || (val.code === 'mchs_discount' && getQueryParameterByName('partner') === 'corp_mchs'));
						this.targetOptionsOld = this.targetOptionsFirst = this.targetOptions;
						this.activeCodes = [];
					}
					// 4711 Kostyl
					if (val === 'product_preferential') {
						this.targets = "Льготная ипотека";
					}
					if (val === 'product_refinancing') {
						this.targets = "Рефинансирование";
					}
					// 4394
					if ((val === 'product_building' && this.realty === 'machine_building') || (val === 'product_ready' && this.realty === 'machine_ready')
					|| (val === 'product_refinancing' && this.realty === 'machine_building') || (val === 'product_refinancing' && this.realty === 'machine_ready')) {
						this.getMachineProgram();
					}

					this.targetOptionsOld = this.targetOptionsFirst = this.targetOptions;
					this.sortOptions();
				}
			},
			getRealtyApixNames() {
				for (let prop in this.productsList) {
					for (let i=0; i < this.realtyItems.length; i++) {
						if (this.realtyItems[i].const === prop) {
							this.realtyItems[i].title = this.productsList[prop].name;
						}
					}
				}
			},
			checkItInn() {
				axios.get(`${this.innRoute}${this.innNumberIt}`, {headers: {'Accept': 'application/vnd.api+json'}})
					.then((response) => {
						this.innChecker = response.data.data.attributes.inn === this.innNumberIt ? 'success' : 'failure';
					}
				)
				.catch(() => {
					this.innChecker = 'failure';
				})
			},
			getDevelopersSlider(event) {
				event !== '' ? this.getDevelopersProduct(event) : this.getDevelopersProduct('product_building');
				this.devFamilyChecker = event === 'product_family' ? true : false;
				this.developersDfoActive = event === 'product_far_east' ? true : false;
				this.$nextTick(() => {
					this.getCalculationsFunctions();
				})
			},
			getDevelopersChildren(event) { // Developers landing function
				this.developersChildren = event;
			},
			getDevelopersRegion(event) { // Developers landing function
				this.developersRegion = event;
				lkStore.developersRegion = event;
				this.checkCurrentRegion();
			},
			getDevelopersSource(event) {
				this.developersSource = event;
			},
			sortOptions() {
				this.$nextTick(() => {
					let withCodes = this.targetOptions.filter(val => this.activeCodes.includes(val.code));
					let withoutCode = this.targetOptions.filter(val => !this.activeCodes.includes(val.code));
					withoutCode.sort((a,b) => {
						return a.index - b.index
					})
					this.targetOptions = [...withCodes, ...withoutCode];
				})
			},
			getMachineProgram() {
				this.products.parameters.minCreditAmount = 300000;
				this.$nextTick(() => {
					this.getTrueOptions('parking');
				})
				if (this.currentRegion === '77' || this.currentRegion === '50' || this.currentRegion === '78' || this.currentRegion === '47') {
					this.amountMaxRegion = 3500000;
				}
				else {
					this.amountMaxRegion = 1500000;
				}
				if (this.loanAmount > this.amountMaxRegion) {
					this.loanAmount = this.amountMaxRegion;
				}
				this.checkStgMaxValue();
			},
			isActive(menuItem) {
				return this.activeOptionsTabs === menuItem;
			},
			setActive(menuItem, flag) {
				switch (flag) {
					case 'tabs':
						if (this.targetSlide === '') {
							this.disabledCombination = [];
							this.mobileCombination = [];
						}
						break;
					case 'mortgage-tabs':
						this.activeMortgageTabs = menuItem;
						if (this.$props.program === '') {
							this.rebates = [];
							this.activeCodes = [];
							this.rateDeduction = 0;
							if (menuItem === 'buy') {
								this.slidesText = this.targetSlide = '' ;
								this.getApixValues('product_building');
								this.realty = 'product_building';
								this.disabledCombination = [];
								this.mobileCombination = [];
							}
							else if (menuItem === 'refin') {
								if (this.realty !== 'product_building' && this.realty !== 'product_ready') {
									this.realty = 'product_building';
								}
								this.getApixValues('product_refinancing');
								this.disabledCombination = [];
								this.visibleCombination = ['product_house','product_building_house', 'pledged', 'new_living_house', 'preferential_house', 'preferential_house_land'];
								this.slidesText = this.targetSlide = '';
							}
							else {
								this.slidesText = this.targetSlide = '' ;
								this.getApixValues('product_secured_loan');
								this.visibleCombination = ['product_building','product_house','product_building_house', 'pledged', 'new_living_house', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land'];
								if (this.realty !== 'product_ready') {
									this.realty='product_ready';
								}
								this.getPledgeMaxSum();
							}
							this.checkStgMaxValue();
							this.checkCurrentRegion();
						}
						else {
							if (this.slidesText === 'product_family' && this.activeMortgageTabs === 'buy') {
								this.visibleCombination = ['pledged', 'new_living_house', 'preferential_house', 'preferential_house_land'];
								this.getRefinMaxSum();
							}
							else if (this.slidesText === 'product_family' && this.activeMortgageTabs === 'refin') {
								this.visibleCombination = ['product_house', 'product_building_house', 'pledged', 'new_living_house', 'preferential_house', 'preferential_house_land'];
								this.getRefinMaxSum();
							}
						}
						break;
					case 'options':
						this.activeOptionsTabs = menuItem;
						break;
				}
				this.$nextTick(() => {
					this.checkProductsCombinations()
				});
				if (flag !== 'options') {
					this.getCalculationsFunctions();
				}
				this.updatePrvSlider();
			},
			checkOkved() {
				let okvedFirstChecker = this.okveds.filter(val => val === this.okved);
				let okvedSecondChecker  = this.okvedsAll.filter(val => this.okveds.indexOf(val.code) !== -1);
				this.okvedChecker = okvedFirstChecker.length > 0 || okvedSecondChecker.length > 0 ? 'success' : 'failure';
			},
			getOkvedDeduction() {
				this.$modal.hide('med');
				this.getCalculationsFunctions();
				this.getTrueOptions('medicine_discount');
			},
			getCalculationsFunctions() {
				this.setInputsValues();
				this.getLoanAmount();
				this.getPrvPercent();
				this.getKZ();
				this.getRate();
				this.getMonthlyPay();
				this.getIncome();
			},
			getBigSums() {
				if (this.bigsumPrograms.includes(this.targetsCode)) {
					if ((this.bigSumRegions.includes(this.currentRegion) && this.loanAmount >= 20000000) || (!this.bigSumRegions.includes(this.currentRegion) && this.loanAmount >= 10000000) ) {
						return this.rate = this.rate + this.bigsumDeduction;
					}
					else {
						return this.rate;
					}
				}
			},
			setTargets(value) {
				if (this.$props.program === '' || this.$props.program === 'product_preferential') {
					switch (value) {
						case 'product_ready':
							if (this.targetSlide === 'product_family' || this.targetSlide === 'product_far_east' || this.targetSlide === 'it_specialist') {
								this.getApixValues(this.targetSlide);
							}
							else if (this.activeMortgageTabs === 'refin') {
								this.getApixValues('product_refinancing');
								if (this.slidesText === 'product_countryside') {
									this.slidesText = '';
								}
							}
							else if (this.activeMortgageTabs === 'pledge') {
								this.getApixValues('product_secured_loan');
							}
							else {
								this.getApixValues('product_ready');
							}
							break;
						case 'product_building':
							if (this.targetSlide === 'product_family' || this.targetSlide === 'product_far_east' || this.targetSlide === 'product_preferential' || this.targetSlide === 'it_specialist') {
								this.getApixValues(this.targetSlide);
							}
							else if (this.activeMortgageTabs === 'refin') {
								this.getApixValues('product_refinancing');
								if (this.slidesText === 'product_countryside') {
									this.slidesText = '';
								}
							}
							else {
								this.getApixValues('product_building');
							}
							break;
						case 'product_house':
							if (this.targetSlide === 'product_family' || this.targetSlide === 'product_preferential' || this.targetSlide === 'it_specialist') {
								this.getApixValues(this.targetSlide);
								if (this.targetSlide === 'product_family') { this.activeCodes = ['option_house'] }
							}
							else if (this.targetSlide === 'product_far_east') {
								this.getApixValues(this.targetSlide);
								this.activeCodes = ['option_house'];
							}
							else {
								this.getApixValues('product_house');
							}
							if (this.$props.izs === 'Y')  {
								this.visibleCombination = ['product_ready', 'product_building', 'pledged', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land'];
								this.disabledCombination = ['product_refinancing', 'product_secured_loan'];
								this.mobileCombination = ['refin', 'pledge'];
							}
							break;
						case 'product_building_house':
							if (this.targetSlide === 'product_family') {
								this.getApixValues('product_family');
								// Family IZS kostyl
								this.targetOptionsFirst = this.targetOptionsFirst.filter(val => val.code !== 'trade-in');
								this.targetOptions = this.targetOptions.filter(val => val.code !== 'trade-in');
							}
							else if (this.targetSlide === 'product_preferential' || this.targetSlide === 'product_far_east' || this.targetSlide === 'it_specialist' ) {
								this.getApixValues(this.targetSlide);
							}
							else {
								this.getApixValues('product_building_house');
							}
							break;
						case 'pledged':
							this.slidesProducts = this.slidesProductsBuy.filter(val => val.code !== 'scientist');
							this.getApixValues('product_ready');
							break;
						case 'new_living_house':
							this.getApixValues('product_building_house');
							this.targetsCode = 'new_living_house';
							this.targets = "Покупка жилого дома до 2 лет с земельным участком";
							this.slidesText = '';
							this.targetSlide = '';
							break;
						case 'machine_building':
							if (this.activeMortgageTabs === 'buy') {
								this.getApixValues('product_building');
							}
							else {
								this.getApixValues('product_refinancing');
							}
							this.targetsCode = 'parking_program';
							break;
						case 'machine_ready':
							if (this.activeMortgageTabs === 'buy') {
								this.getApixValues('product_ready');
							}
							else {
								this.getApixValues('product_refinancing');
							}
							this.targetsCode = 'parking_program';
							break;
						case 'preferential_house':
						case 'preferential_house_land':
							this.getApixValues('product_preferential');
							this.targetsCode = 'product_economic_way_tranche';
							this.purposeLk = value === 'preferential_house' ? 'HOUSE_CONSTRUCTION' : 'HOUSE_CONSTRUCTION_WITH_LAND';
							this.products.interestAmount[0].interestPercent = 6.3;
							this.targetOptions = this.targetOptions.filter((val) => val.code === 'easy_mortgage');
							this.targetOptionsOld = this.targetOptionsFirst = this.targetOptions;
							break;
					}
					if ((value !== 'product_house' && this.targetsCode !== 'product_family') || (value !== 'product_house' && this.targetsCode === 'product_far_east')) {
						this.activeCodes = [];
					}
					this.rebates = [];
					this.rateDeduction = 0;
					this.getCalculationsFunctions();
					this.updatePrvSlider();
					this.checkProductsCombinations();
					this.getDefaultOptions(this.targetsCode);
				}
			},
			sliderText(value) {
				if (this.slidesText === value) {
					this.slidesText = '';
					if (event.target.dataset.value && event.target.dataset.value !== null) {
						this.disabledCombination = [];
						this.mobileCombination = [];
						this.activeCodes = [];
						if (this.realty === 'preferential_house' || this.realty === 'preferential_house_land') {
							this.realty = 'product_building';
						}
						if (this.targetSlide === 'med') {
							this.okvedChecker = '';
						}
						this.targetSlide = '';
						this.checkProductsCombinations();
						if (this.targetsCode === 'product_family' && this.activeMortgageTabs === 'refin') {
							this.setActive('refin', 'mortgage-tabs')
						}
						else {
							this.getApixValues(this.realty);
						}
						this.getCalculationsFunctions();
						this.rateDeduction = 0;
					}
				}
				else {
					this.slidesText = value;
					this.disabledCombination = [];
					this.activeCodes = [];
					this.rateDeduction = 0;
					this.rebates = [];
					this.activeCyclon();
					switch (value) {
						case 'product_preferential':
							this.getApixValues('product_preferential');
							if (this.realty !== 'product_building') {
								this.realty='product_building';
							}
							this.visibleCombination = ['product_ready', 'pledged', 'new_living_house', 'machine_building', 'machine_ready'];
							break;
						case 'product_family':
							this.getApixValues('product_family');
							this.visibleCombination = this.activeMortgageTabs === 'refin' ? ['product_house', 'product_building_house', 'pledged', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land']
							: ['product_house', 'pledged', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land'];
							if (this.realty !== 'product_building' && this.realty !== 'product_ready') {
								this.realty='product_building';
							}
							break;
						case 'product_far_east':
							if (this.targetsCode === 'product_building_house' || this.realty === 'product_building_house') {
								this.getApixValues('product_far_east_house');
								this.visibleCombination = ['pledged', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land'];
								this.disabledCombination.push('product_refinancing','product_secured_loan');
								this.mobileCombination.push('refin','pledge');
							}
							else {
								this.getApixValues('product_far_east');
								this.visibleCombination = ['pledged', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land'];
								this.disabledCombination.push('product_refinancing','product_secured_loan');
								this.mobileCombination.push('refin','pledge');
							}
							this.currentRegion = '25';
							break;
						case 'it_specialist':
							this.itIncome = 0;
							this.getApixValues('it_specialist');
							this.targets = 'Ипотека для IT-специалистов';
							this.visibleCombination = ['pledged', 'new_living_house', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land'];
					}
					this.targetSlide = value;
					this.okvedChecker = '';
				}
				this.checkCurrentRegion();
				this.getCalculationsFunctions();
				this.updatePrvSlider();
				this.checkStgMaxValue();
				this.$nextTick(() => {
					this.checkProductsCombinations()
					this.checkDfoRegions();
				});

			},
			checkDfoRegions() {
				if (this.$refs.regionsel) {
					const regionsAll = this.$refs.regionsel.querySelectorAll('.d-select__item');

					for (let i = 0; i < regionsAll.length; i++) {
						const regionCode = regionsAll[i].getAttribute('value');
						if ((this.targetsCode === 'product_far_east' || this.targetsCode === 'product_far_east_house') && !this.developersDfoRegions.includes(regionCode)) {
							regionsAll[i].classList.add('hidden');
						}
						else {
							if (regionsAll[i].classList.contains('hidden')) {
								regionsAll[i].classList.remove('hidden');
							}
						}
					}
				}
			},
			checkStgMaxValue() {
				switch(this.targetSlide) {
					case 'product_far_east':
						this.stgMax = 30000000;
						break;
					case 'product_preferential':
						this.stgMax = this.currentRegion !== '77' && this.currentRegion !== '78' ? 15000000 : 40000000;
						break;
					case 'product_family':
						this.stgMax = 50000000;
						break;
					default:
						this.stgMax = 55000000;
				}

				if (this.realtySlider) {
					this.realtySlider.updateOptions({
						range: {
							'min': this.stgMin,
							'max': this.stgMax
						}
					});
				}
			},
			checkProductsCombinations() {
				if (this.$refs.goalsel) {
					var productsAll = this.$refs.goalsel.querySelectorAll('.d-select__item');
					for (let i = 0; i < productsAll.length; i++) {
						const productCode = productsAll[i].getAttribute('value');
						if (this.visibleCombination.indexOf(productCode) !== -1) {
							productsAll[i].classList.add('hidden');
						}
						else {
							if (productsAll[i].classList.contains('hidden')) {
								productsAll[i].classList.remove('hidden');
							}
						}
					}
				}
			},
			bshowToggle() {
				if (this.bshow === 'Показать все') {
					this.$refs.cards.classList.add('mortgage-calcnew__cards_h-avto');
					this.bshow = "Скрыть";
				}
				else {
					this.$refs.cards.classList.remove('mortgage-calcnew__cards_h-avto');
					this.bshow = "Показать все";
				}
			},
			checkOptionDate(option) {
				if (option.reviewFinish) {
					if (dayjs().diff(option.reviewFinish, 'days') > 1) return true
				}
			},
			parseOptions(value) {
				if (value) {
					for (let i=0; i < value.length; i++) {
						const dateChecker = this.checkOptionDate(value[i]);
						if (Object.keys(this.optionsShow).indexOf(value[i].code) === -1 || dateChecker) {
							value.splice(i, 1);
						}
						else {
							value[i].index = this.optionsShow[value[i].code];
							for (let prop in this.optionsRenames) {
								if (this.optionsRenames[prop].codes.includes(value[i].code)) {
									value[i].name = this.optionsRenames[prop].name;
									if ((this.optionsRenames[prop].comment && this.optionsRenames[prop].targetsComment === 'all') || (this.optionsRenames[prop].comment && this.optionsRenames[prop].targetsComment === this.targetsCode)) {
										value[i].comment = this.optionsRenames[prop].comment;
									}
								}
							}
						}
					}
				}

				this.optionsCounter = this.targetOptions.length;
				return value;
			},
			getTrueOptions(code) {
				if (this.targetOptions.length > 0) {
					let	trueData = this.targetOptions.filter((val) => {return val.code === code });
					let targetsCodes = trueData.length > 0 ? trueData[0].options.map((val) => { return val.code }) : [];

					if (targetsCodes.length > 0) {
						if (this.activeCodes.indexOf(code) === -1) {
							let newOptions;

							if ((code === 'medicine_discount' && this.okvedChecker !== 'success')) {
								this.showSpecialWindow(code);
							}
							else {
								this.activeCodes.push(code);
								if (this.activeCodes.length <= 1) {
									newOptions = this.targetOptions.filter((val) => { return targetsCodes.indexOf(val.code) !== -1 });
									newOptions.unshift(trueData[0]);
									this.targetOptionsPrevious[code] = this.targetOptions;
								}
								else {
									this.targetOptionsPrevious[code] = this.targetOptions;
									let halfOptions = this.targetOptions.filter((val) => { return targetsCodes.indexOf(val.code) !== -1 });
									newOptions = [];
									for (let i = 0; i < halfOptions.length; i++) {
										if (this.optionsCodes.indexOf(halfOptions[i]) !== -1) { newOptions.push(halfOptions[i]) }
									}
									newOptions.splice(this.activeCodes.length - 1, 0, trueData[0]);
								}
								this.optionsCodes = this.targetOptions = newOptions;
								this.targetOptionsOld = this.targetOptions;
								let trOption = this.targetOptions.filter((val) => { return val.code === code });
								let correction = trOption[0].interestCorrection;
								// 5110, 5296 Kostyl
								if (code === 'easy_mortgage' && this.targetsCode === 'it_specialist') {
									correction.value = 0
								}

								if (correction.length !== 0) {
									this.rateDeduction = this.rateDeduction + correction.value;
								}

								// 5044 Kostyl
								if (code === 'far_east_family' || (code === 'easy_mortgage' && this.activeCodes.includes('far_east_family'))) {
									this.rateDeduction = this.developersDfoDeduction;
								}

								if (code === 'salary_client') {
									let rebatesChecker = this.rebates.filter(val => val.code === code);
									if (rebatesChecker.length === 0) { this.rebates.push({"code": code === 'salary_client' ? 'salary' : code, "value": this.rateDeduction}) }
								}

								if (code === 'tech_option_d' && this.developersFlag) {
									this.childrenOption = true;
								}

								if (code === 'developer_subsidy_middle' || code === 'developer_subsidy_max' || code === 'developer_subsidy_min') {
									this.getMinPeriod(code);
									this.getCalculationsFunctions();
								}

								if (this.prvPercent < 20 && (this.activeCodes.includes('developer_subsidy_middle') || this.activeCodes.includes('developer_subsidy_max')
								|| this.activeCodes.includes('developer_subsidy_min') || this.activeCodes.includes('easy_mortgage'))) {
									this.$nextTick(() => {
										this.getCalculationsFunctions();
									})
								}

								// 3706 Kostyl
								if ((code === 'apartments' && this.developersFlag) || (code === 'parking' && this.developersFlag)) {
									code === 'apartments' ? this.hiddenOptions.push('parking') : this.hiddenOptions.push('apartments');
									this.getApixValues('product_building');
									this.getCalculationsFunctions();
								}
							}
						}
						else {
							this.checkTabsOptions(code);
							let trueOption = this.targetOptions.filter(val => val.code === code);
							let deduction = trueOption[0].interestCorrection.value < 0 ? Math.abs(trueOption[0].interestCorrection.value) : -trueOption[0].interestCorrection.value;
							deduction = isNaN(deduction) ? 0 : deduction;
							this.rateDeduction = this.rateDeduction + deduction;
							if (code === 'medicine_discount') {
								this.showSpecialWindow(code, 'close');
							}

							// 5044 Kostyl
							if (code === 'far_east_family') {
								this.rateDeduction = !this.activeCodes.includes('easy_mortgage') ? 0 : Math.abs(this.developersDfoDeduction);
								if (this.activeCodes.includes('salary_client_family')) this.rateDeduction = this.targetOptions.filter(val => val.code === 'salary_client_family')[0].interestCorrection.value;
							}
							else if (code === 'easy_mortgage' && this.activeCodes.includes('far_east_family')) {
								this.rateDeduction = this.developersDfoDeduction;
							}

							if (code === 'tech_option_d' && this.developersFlag) {
								this.childrenOption = false;
							}

							if (code === 'developer_subsidy_middle' || code === 'developer_subsidy_max' || code === 'developer_subsidy_min') {
								this.getCalculationsFunctions();
							}

							this.activeCodes.unshift(code);
							this.activeCodes = this.activeCodes.filter((val) => {return val !== code });
							this.rebates = this.rebates.filter(val => val.code !== code);
							this.hiddenOptions = [];
						}
					}

					if (this.recalculation.indexOf(code) !== -1) {
						this.getCalculationsFunctions();
					}

					this.activeCyclon();
					this.updatePrvSlider();
					if (this.activeMortgageTabs === 'refin') { this.getRefinMaxSum() }
				}
			},
			activeCyclon() {
				let i;
				for (i = 0; i < this.targetOptions.length; i++) {
					this.optcheck[this.targetOptions[i].code] = false;
				}
				for (i = 0; i < this.activeCodes.length; i++) {
					this.optcheck[this.activeCodes[i]] = true;
				}
			},
			checkTabsOptions(dataCode) {
				var _this = this;
				switch (this.activeOptionsTabs) {
					case 'all':
						if (this.activeCodes.length <= 1) {
							this.targetOptions = this.targetOptionsFirst;
							this.optionsCodes = [];
							this.activeCodes = [];
						}
						else {
							this.activeCodesFilter(dataCode);
						}
						break;
					case 'rate':
						if (this.activeCodes.length <= 1) {
							this.targetOptions = this.targetOptionsFirst.filter(function(val) { return _this.rateOptions.indexOf(val.code) !== -1 });
							this.optionsCodes = [];
							this.activeCodes = [];
						}
						else {
							this.activeCodesFilter(dataCode);
						}
						break;
					case 'action':
						if (this.activeCodes.length <= 1) {
							this.targetOptions = this.targetOptionsFirst.filter(function(val) { return _this.actionOptions.indexOf(val.code) !== -1 });
							this.optionsCodes = [];
							this.activeCodes = [];
						}
						else {
							this.activeCodesFilter(dataCode);
						}
						break;
				}
			},
			activeCodesFilter(dataCode) {
				this.activeCodes = this.activeCodes.filter((val) => { return val !== dataCode });
				let trueTargets = this.targetOptionsPrevious[Object.keys(this.targetOptionsPrevious)[0]];
				if (Object.keys(this.targetOptionsPrevious).length <= 1) {
					switch (this.activeOptionsTabs) {
						case 'all':
							this.targetOptions = this.targetOptionsPrevious[Object.keys(this.targetOptionsPrevious)[0]];
							break;
						case 'rate':
							this.targetOptions = trueTargets.filter((val) => {return this.rateOptions.indexOf(val.code) !== -1 });
							break;
						case 'action':
							this.targetOptions = trueTargets.filter((val) => { return this.actionOptions.indexOf(val.code) !== -1 });
							break;
					}
				}
				else {
					let objLength = Object.keys(this.targetOptionsPrevious).length;
					switch (this.activeOptionsTabs) {
						case 'all':
							this.targetOptions = this.targetOptionsPrevious[dataCode];
							break;
						case 'rate':
							trueTargets = this.targetOptionsPrevious[Object.keys(this.targetOptionsPrevious)[objLength-1]];
							this.targetOptions = trueTargets.filter((val) => { return this.rateOptions.indexOf(val.code) !== -1 });
							break;
						case 'action':
							trueTargets = this.targetOptionsPrevious[Object.keys(this.targetOptionsPrevious)[objLength-1]];
							this.targetOptions = trueTargets.filter((val) => { return this.actionOptions.indexOf(val.code) !== -1 });
							break;
					}
				}
			},
			setInputsValues() {
				if (this.products.parameters) {
					this.pledgeMin = this.realtyPrice * (this.products.parameters.minDebtToPledge / 100);
					this.pledgeMax = this.realtyPrice * (this.products.parameters.maxDebtToPledge / 100);
					this.pledgeMinPrv = this.products.parameters.minDebtToPledge;
					this.pledgeMaxPrv = this.products.parameters.maxDebtToPledge;
					this.periodMin = this.activeCodes.includes('developer_subsidy_max') || this.activeCodes.includes('developer_subsidy_middle') || this.activeCodes.includes('developer_subsidy_min')
									? this.periodMin : this.products.parameters.minCreditCalcPeriod / 12;
					this.periodMax = this.products.parameters.maxCreditCalcPeriod / 12;
					this.borrowermin = this.products.borrowerReqs.minAge;
					this.borrowermax = this.products.borrowerReqs.maxAge;

					if (this.periodSlider) {
						this.periodSlider.updateOptions({
							range: {
								'min': this.periodMin,
								'max': this.periodMax
							}
						});
					}

					if (this.pledgeSlider && !this.developersFlag) {
						this.updatePrvSlider();
					}
				}
			},
			getMinPeriod(val) {
				if (val === 'developer_subsidy_max') {
					this.periodMin = 25;
				}
				else if (val === 'developer_subsidy_middle') {
					this.periodMin = 15;
				}
				else if (val === 'developer_subsidy_min') {
					this.periodMin = 10;
				}

				this.period = this.period < this.periodMin ? this.periodMin : this.period;
				if (this.periodSlider) {
					this.periodSlider.updateOptions({
						range: {
							'min': this.periodMin,
							'max': this.periodMax
						}
					});
				}
			},
			getPrvPercent() {
				this.prvPercent = Math.round((this.pledge / this.realtyPrice) * 100);
			},
			getKZ() {
				if (this.activeMortgageTabs === 'buy') {
					this.kz = Math.round((this.realtyPrice - this.pledge) / this.realtyPrice * 100);
					// Developers landing only
					if ((this.activeCodes.includes('easy_mortgage') || this.activeCodes.includes('developer_subsidy_middle') || this.activeCodes.includes('developer_subsidy_max') || this.activeCodes.includes('developer_subsidy_min'))
					&& this.kz > 80) {
						this.kz = 80;
					}
				}
				else {
					this.kz = (this.loanAmount / this.realtyPrice) * 100;
				}
				return this.kz;
			},
			getRate() {
				if (this.products.interestAmount) {
					for (let i=0; i < this.products.interestAmount.length; i++) {
						if (!this.products.interestAmount[i].minCreditToPledge && !this.products.interestAmount[i].maxCreditToPledge) {
							this.rate = this.products.interestAmount[i].interestPercent + this.rateDeduction;
						}
						else {
							if ((this.kz >= this.products.interestAmount[i].minCreditToPledge && this.kz <= this.products.interestAmount[i].maxCreditToPledge)
								|| (this.kz >= this.products.interestAmount[i].minCreditToPledge && this.kz > this.products.interestAmount[i].maxCreditToPledge)) {
								this.rate = this.products.interestAmount[i].interestPercent + this.rateDeduction;
							}
						}
					}
					this.getBigSums();
				}
			},
			getLoanAmount() {
				if (this.activeMortgageTabs === 'buy') {
					this.loanAmount = Math.round(this.realtyPrice - this.pledge);
					this.checkLoanAmount();
				}
				else {
					this.checkLoanAmount();
					if (this.loanAmount > this.realtyPrice) {
						this.loanAmount = this.realtyPrice;
					}
				}
			},
			checkLoanAmount() {
				if (this.products.parameters) {
					if (this.loanAmount > this.amountMaxRegion) {
						this.loanAmount = this.amountMaxRegion;
					}
					if (this.loanAmount < this.products.parameters.minCreditAmount) {
						this.loanAmount = this.products.parameters.minCreditAmount;
					}
				}
			},
			getMonthlyPay() {
				let monthlyPaymentRate = +((this.rate / 12 / 100).toFixed(7));
				this.monthlyPay = this.loanAmount * monthlyPaymentRate / (1-Math.pow(1 + monthlyPaymentRate, - (this.period * 12 -1)));
				return this.monthlyPay;
			},
			getIncome() {
				this.income = Math.round(this.monthlyPay / 0.6);
			},
			checkCurrentRegion() {
				if (this.products.maxCreditAmount) {
					if (!this.developersFlag) {
						let regions = this.products.maxCreditAmount.filter((val) => {return val.region});
						let regionsCommon = this.products.maxCreditAmount.filter((val) => {return !val.region});
						let currentReg = regions.filter((val) => {return val.region.code === this.currentRegion});
						if (currentReg.length === 0) {
							this.amountMaxRegion = regionsCommon[0].maxCreditAmount;
						}
						else {
							this.amountMaxRegion = currentReg[0].maxCreditAmount;
						}
					}
					else {
						this.currentRegion = lkStore.developersRegion;
						if (this.developersDfoRegions.includes(lkStore.developersRegion)) {
							this.developersDfoShow = true;
						}
						if (this.currentRegion === '77' || this.currentRegion === '78' && !this.developersDfoActive) {
							this.amountMaxRegion = 12000000;
						}
						else if (this.targetsCode === 'product_family' || this.targetsCode === 'product_preferential' || this.developersDfoActive) {
							this.amountMaxRegion = 6000000;
						}
						else {
							this.amountMaxRegion = 8000000;
						}
					}

					if (this.targetsCode === 'product_refinancing') {
						this.getRefinMaxSum();
						this.checkLoanAmount();
					}
					else if (this.targetsCode === 'product_secured_loan') {
						this.getPledgeMaxSum();
						this.checkLoanAmount();
					}
				}
				if (!this.developersFlag) this.getCalculationsFunctions();
			},
			checkDevelopersDfo() { // Developers landing function
				if (this.developersDfoRegions.includes(lkStore.developersRegion) && this.period >= 3 && this.period <= 20 && this.loanAmount <= 6000000) {
					this.developersDfoShow = true;
				}
				else {
					this.developersDfoShow = false;
				}
			},
			getRefinMaxSum() {
				let coef;
				if ((this.targetSlide === 'product_family' && this.activeCodes.includes('easy_mortgage'))
				|| (this.targetSlide === 'product_countryside' && this.activeCodes.includes('easy_mortgage'))
				|| (this.targetSlide !== 'product_countryside' && this.targetSlide !== 'product_family' && this.activeCodes.includes('easy_mortgage'))
				|| (this.activeCodes.includes('easy_mortgage'))) {
					coef = 0.80;
				}
				else if (this.targetSlide === 'product_countryside' && !this.activeCodes.includes('easy_mortgage')
				|| (this.targetSlide !== 'product_countryside' && this.targetSlide !== 'product_family' && !this.activeCodes.includes('easy_mortgage'))
				|| this.activeCodes.includes('salary_client')) {
					coef = 0.90;
				}
				else {
					coef = 0.85;
				}

				let refinMax;
				if ((this.currentRegion === '1' || this.currentRegion === '2')
				&& (this.realty !== 'machine_building' || this.realty !== 'machine_ready')) {
					refinMax = this.realtyPrice * coef < this.refinMaxSum.main ? this.realtyPrice * coef : this.refinMaxSum.main;
					this.refinMax = this.realtyPrice <= this.refinMaxSum.main ? this.realtyPrice * coef : refinMax;
				}
				else if ((this.currentRegion === '1' || this.currentRegion === '2' || this.currentRegion === '6')
				&& (this.realty === 'machine_building' || this.realty === 'machine_ready')) {
					refinMax = this.realtyPrice * coef < this.refinMachineSum.main ? this.realtyPrice * coef : this.refinMachineSum.main;
					this.refinMax = this.realtyPrice <= this.refinMachineSum.main ? this.realtyPrice * coef : refinMax;
				}
				else if ((this.currentRegion !== '1' || this.currentRegion !== '2' || this.currentRegion !== '6')
				&& (this.realty === 'machine_building' || this.realty === 'machine_ready')) {
					refinMax = this.realtyPrice * coef < this.refinMachineSum.other ? this.realtyPrice * coef : this.refinMachineSum.other;
					this.refinMax = this.realtyPrice <= this.refinMachineSum.other ? this.realtyPrice * coef : refinMax;
				}
				else {
					refinMax = this.realtyPrice * coef < this.refinMaxSum.other ? this.realtyPrice * coef : this.refinMaxSum.other;
					this.refinMax = this.realtyPrice <= this.refinMaxSum.other ? this.realtyPrice * coef : refinMax;
				}
				this.loanSlider.updateOptions({
					range: {
						'min': this.amountMin,
						'max': this.refinMax
					}
				});
				if (this.loanAmount > this.refinMax) {
					this.loanAmount = this.refinMax
				}
				this.loanSlider.set(this.loanAmount)
			},
			getPledgeMaxSum() {
				this.amountMin = this.realtyPrice === this.stgMin ? this.realtyPrice * 0.65 : this.stgMin;
				if (this.currentRegion === '77' || this.currentRegion === '78') {
					this.pledgeMaxRealty = this.realtyPrice <= this.refinMaxSum.main ? this.realtyPrice * 0.65 : this.refinMaxSum.main;
				}
				else {
					this.pledgeMaxRealty = this.realtyPrice <= this.refinMaxSum.other ? this.realtyPrice * 0.65 : this.refinMaxSum.other;
				}
				this.loanSlider.updateOptions({
					range: {
						'min': this.amountMin,
						'max': this.pledgeMaxRealty
					}
				});
			},
			updatePrvSlider() {
				if (this.products.parameters) {
					let pledgeMinValue;
					if (this.targetsCode === 'product_building' || this.targetsCode === 'product_ready' || this.targetsCode === 'product_countryside') {
						pledgeMinValue = this.products.parameters.minDebtToPledge;
					}
					else {
						pledgeMinValue = 100 - this.products.parameters.maxDebtToPledge;
					}

					if ((this.activeCodes.indexOf('easy_mortgage') !== -1 && this.realty !== 'product_house' && this.targetsCode !== 'it_specialist' && !this.developersFlag) || (this.targetsCode === 'product_far_east' && this.realty === 'product_house')
					|| (this.realty === 'preferential_house' || this.realty === 'preferential_house_land') || (this.targetsCode === 'product_family' && this.realty === 'product_house') || (this.targetsCode === 'product_preferential' && this.realty === 'product_house')
					|| (this.targetsCode === 'it_specialist' && this.realty === 'product_house')) {
						pledgeMinValue = 20;
					}
					else if ((this.targetsCode === 'product_family' && this.realty === 'product_building_house') || (this.developersFlag && this.activeCodes.indexOf('easy_mortgage') !== -1)) {
						pledgeMinValue = 15;
					}
					if (typeof this.realtyPrice === 'string') {
						this.realtyPrice = Number(this.realtyPrice.replace(/\D/g, ''));
					}
					else {
						this.pledgeMin = Math.round(this.realtyPrice * (pledgeMinValue / 100));
						this.pledgeMax = Math.round(this.realtyPrice * (this.products.parameters.maxDebtToPledge / 100));
					}
					if (this.pledge < this.pledgeMin) {
						this.pledge = this.pledgeMin;
						this.getPrvPercent();
					}
					if (this.pledge > this.pledgeMax) {
						this.pledge = this.pledgeMax;
						this.getPrvPercent();
					}
					if (this.realtyPrice - this.pledge >= this.amountMaxRegion) {
						this.pledge = Math.round(this.realtyPrice - this.amountMaxRegion);
					}
					if (this.realtyPrice - this.pledge < this.products.parameters.minCreditAmount) {
						this.pledge = Math.round(this.realtyPrice - this.products.parameters.minCreditAmount);
					}
					if (this.matcap) {
						if (this.pledge !== this.money + this.maternalCapital) {
							this.money = this.pledge - this.maternalCapital;
						}
					}

					if (this.pledgeSlider) {
						this.pledgeSlider.updateOptions({
							range: {
								'min': this.pledgeMin,
								'max': this.pledgeMax
							}
						});
					}
				}
			},
			updateAmountSlider() {
				if (this.activeMortgageTabs === 'buy' && this.realtyPrice - this.pledge > this.amountMaxRegion) {
					this.realtyPrice = this.amountMaxRegion;
					this.realtySlider.set(this.realtyPrice);

					this.realtySlider.updateOptions({
						range: {
							'min': this.stgMin,
							'max': this.stgMax
						}
					});
					this.getPrvPercent();
				}
			},
			getRegionsList() {
				axios.get(this.regionsUrl, {headers: {'Accept': 'application/vnd.api+json'}})
				.then((response) => {
					this.regionsList = response.data.data.map((val) => { return {'code':val.attributes.code, 'title': val.attributes.name}});
					this.regionsList.forEach(element => element.const = element.code);
					this.regionsList = this.regionsList.filter(element => element.const !== '91' && element.const !== '92');
				})
			},
			showSpecialWindow(program, flag) {
				if (flag === 'close') {
					this.okvedChecker = program === 'medicine_discount' ? '' : this.okvedChecker;
					this.getCalculationsFunctions();
					this.targetsCode === 'new_living_house' ? this.getApixValues('product_building_house') : this.getApixValues(this.targetsCode);
					this.visibleCombination = this.activeMortgageTabs === 'refin' ? ['product_house','product_building_house', 'pledged', 'machine_building', 'machine_ready', 'preferential_house', 'preferential_house_land'] : ['preferential_house', 'preferential_house_land'];
					this.checkProductsCombinations();
					this.activeCodes = [];
				}
				else {
					if (program === 'medicine_discount') {
						this.$modal.show('med');
					}
				}
			},
			successPartner() {
				this.$modal.hide('send');
				this.$modal.show('sendPartnerSuccess');
			},
			getDefaultOptions(val) {
				if (val === 'product_family' && !this.developersFlag) {
					if (!this.activeCodes.includes('far_east_family') && this.developersDfoRegions.includes(this.currentRegion)) {
						this.getTrueOptions('far_east_family');
					}
					else if (this.activeCodes.includes('far_east_family')) {
						this.getTrueOptions('far_east_family');
					}
					if (!this.activeCodes.includes('salary_client_family')) {this.getTrueOptions('salary_client_family')}
				}
				else if (val === 'product_preferential' && this.realty !== 'product_house' && this.realty !== 'product_building_house' && !this.developersFlag) {
					if (!this.activeCodes.includes('salary_preferential')) {this.getTrueOptions('salary_preferential')}
				}
				if (getQueryParameterByName('partner') === 'corp_mchs') {
					if (!this.activeCodes.includes('mchs_discount')) {this.getTrueOptions('mchs_discount')}
				}
			},
			getDefaultProgram() {
				if (this.$props.program === 'product_family') {
					this.sliderText('product_family');
					this.hiddenFields = ['slider'];
				}
				else if (this.$props.program === 'product_ready' || this.$props.program === 'product_building') {
					this.realty = this.$props.program;
					this.getApixValues(this.$props.program);
					this.hiddenFields = ['realty', 'tabs', 'slider', 'goals'];
				}
				else if (this.$props.program === 'product_refinancing') {
					this.getApixValues(this.$props.program);
					this.hiddenFields = ['tabs', 'slider'];
					this.visibleCombination = ['product_house','product_building_house', 'pledged', 'new_living_house', 'preferential_house', 'preferential_house_land'];
					this.checkProductsCombinations();
					this.getCalculationsFunctions();
				}
				else if (this.$props.program === 'it_specialist') {
					this.sliderText('it_specialist');
					this.hiddenFields = ['tabs', 'slider'];
				}
				else if (this.$props.program === 'product_preferential') {
					this.sliderText('product_preferential');
					this.hiddenFields = ['tabs', 'slider'];
				}
				else {
					if (this.$props.izs !== 'Y') {
						this.getApixValues('product_building');
					}
				}
			},
			createSliders() {
				this.realtySlider = noUiSlider.create(this.$refs.mortgagePrice, {
					start: [this.realtyPrice],
					connect: 'lower',
					step: 250000,
					initial: this.realtyPrice,
					range: {
						'min': this.stgMin,
						'max': this.stgMax
					},
					format: {
						to: (value) => {
							return value + ',-';
						},
						from: (value) => {
							return Number(value.replace(',-', ''));
						}
					}
				});

				this.realtySlider.on('change', (val) => {
					val = Number(val[0].replace(',-',''));
					this.realtyPrice = val;
					this.getRealtyPrice();
				});

				this.realtySlider.on('update', (val) => {
					val = Number(val[0].replace(',-',''));
					this.$refs.realtyInput.value=Math.floor(val) + ' ₽';
				});

				this.$refs.realtyInput.addEventListener('change', () => {
					this.realtyPrice = Number(this.realtyPrice);
					this.getRealtyPrice();
				})

				this.$refs.realtyInput.addEventListener('click', () => {
					this.$refs.realtyInput.value = '';
				})

				this.loanSlider = noUiSlider.create(this.$refs.mortgageLoan, {
					start: [this.loanAmount],
					connect: 'lower',
					step: 250000,
					initial: this.loanAmount,
					range: {
						'min': this.amountMin,
						'max': this.realtyPrice
					},
					format: {
						to: (value) => {
							return value + ',-';
						},
						from: (value) => {
							return Number(value.replace(',-', ''));
						}
					}
				})

				this.loanSlider.on('change', (val) => {
					val = Number(val[0].replace(',-',''));
					this.loanAmount = val;
					this.getCalculationsFunctions();
				})

				this.loanSlider.on('update', (val) => {
					val = Number(val[0].replace(',-',''));
					this.$refs.loanInput.value = this.filters.formatMoney(Math.floor(val));
				})

				this.$refs.loanInput.addEventListener('change', () => {
					if (this.loanAmount > this.realtyPrice) {
						this.loanAmount = this.realtyPrice;
					}
					this.loanSlider.set(this.loanAmount);
				})

				this.$refs.loanInput.addEventListener('blur', () => {
					this.getCalculationsFunctions();
				})

				this.$refs.loanInput.addEventListener('click', () => {
					this.$refs.loanInput.value = '';
				})

				this.pledgeSlider = noUiSlider.create(this.$refs.mortgagePledge, {
					start: [this.pledge],
					connect: 'lower',
					step: 250000,
					initial: this.pledge,
					range: {
						'min': this.pledgeMin,
						'max': this.pledgeMax
					},
					format: {
						to: (value) => {
							return value + ',-';
						},
						from: (value) => {
							return Number(value.replace(',-', ''));
						}
					}
				})

				this.pledgeSlider.on('change', (val) => {
					val = Number(val[0].replace(',-',''));
					this.pledge = val;
					this.$nextTick(() => {
						this.updateAmountSlider();
						this.updatePrvSlider();
						this.getCalculationsFunctions();
					});
				})

				this.pledgeSlider.on('update', (val) => {
					val = Number(val[0].replace(',-',''));
					this.$refs.pledgeInput.value=Math.floor(val) + ' ₽';
				})

				this.$refs.pledgeInput.addEventListener('blur', () => {
					this.pledge = Number(this.pledge);
					this.pledgeSlider.set(this.pledge);
					this.$nextTick(() => {
						this.updateAmountSlider();
						this.updatePrvSlider();
						this.getCalculationsFunctions();
					});
				})

				this.$refs.pledgeInput.addEventListener('click', () => {
					this.$refs.pledgeInput.value = '';
				})

				this.periodSlider = noUiSlider.create(this.$refs.mortgagePeriod, {
					start: [this.period],
					connect: 'lower',
					step: 1,
					initial: this.period,
					range: {
						'min': this.periodMin,
						'max': this.periodMax
					},
					format: {
						to: (value) => {
							return value + ',-';
						},
						from: (value) => {
							return Number(value.replace(',-', ''));
						}
					}
				})

				this.periodSlider.on('change', (val) => {
					val = Number(val[0].replace(',-',''));
					this.period = Math.floor(val);
					this.getCalculationsFunctions();
				});

				this.periodSlider.on('update', (val) => {
					this.$nextTick(()=> {
						val = Number(val[0].replace(',-',''));
						this.period = Math.floor(val);
					})
				});

				this.$refs.periodInput.addEventListener('change', () => {
					this.getCalculationsFunctions();

					if (this.period > this.periodMax) {
						this.period = this.periodMax;
					}
					if (this.period < this.periodMin) {
						this.period = this.periodMin;
					}
					this.periodSlider.set(this.period);
				})

				this.$refs.periodInput.addEventListener('blur', () => {
					var per = this.filters.periodString(this.period)
					this.$refs.periodInput.value=per;
				})

				this.$refs.matcapInput.addEventListener('change', () => {
					if (Number(this.maternalCapital) > Number(this.matcapMax)) {
						this.maternalCapital = this.matcapMax;
					}
					if (Number(this.maternalCapital) < Number(this.matcapMin)) {
						this.maternalCapital = this.matcapMin;
					}
					this.money = this.pledge - this.maternalCapital;
					if (this.pledge < this.pledgeMin) {
						this.pledge = this.pledgeMin;
						this.money = this.pledge - this.maternalCapital;
					}
					if (this.pledge > this.pledgeMax) {
						this.pledge = this.pledgeMax;
					}
				})

				this.$refs.moneyInput.addEventListener('change', () => {
					if (Number(this.money) > Number(this.pledgeMax)) {
						this.money = Number(this.pledgeMax) - Number(this.maternalCapital);
					}
					if (Number(this.money) < Number(this.moneyMin)) {
						this.money = this.pledgeMax;
					}
					this.pledge = Number(this.maternalCapital) + Number(this.money);
					if (this.pledge < this.pledgeMin) {
						this.pledge = this.pledgeMin;
						this.money = this.pledge - this.maternalCapital;
					}
					if (this.pledge > this.pledgeMax) {
						this.pledge = this.pledgeMax;
					}
					this.pledgeSlider.set(this.pledge);
					this.getPrvPercent();
					this.$nextTick(() => {
						this.getCalculationsFunctions()
					});
				})

				this.$refs.moneyInput.addEventListener('click', () => {
					this.$refs.moneyInput.value = '';
				})

				this.itSlider = noUiSlider.create(this.$refs.itIncome, {
					start: [this.itIncome],
					connect: 'lower',
					step: 1,
					initial: this.itIncome,
					range: {
						'min': 0,
						'max': 10000000
					},
					format: {
						to: (value) => {
							return value + ',-';
						},
						from: (value) => {
							return Number(value.replace(',-', ''));
						}
					}
				})

				this.itSlider.on('change', (val) => {
					val = Number(val[0].replace(',-',''));
					this.itIncome = Math.floor(val);
				});

				this.itSlider.on('update', (val) => {
					this.$nextTick(()=> {
						val = Number(val[0].replace(',-',''));
						this.itIncome = Math.floor(val);
					})
				});

				this.$refs.itInput.addEventListener('change', () => {
					if (this.itIncome > 10000000) {
						this.itIncome = 10000000;
					}
					if (this.itIncome < 0) {
						this.itIncome = 0;
					}
				})
			},
			getDevelopersProduct(val) {
				this.rateDeduction = 0;
				this.activeCodes = [];
				this.getApixValues(val);
				this.checkCurrentRegion();
				this.getCalculationsFunctions();
			},
			getRealtyPrice() {
				this.realtySlider.set(this.realtyPrice);
				this.$nextTick(() => {
					this.getCalculationsFunctions()
				})

				if (this.realtyPrice > this.stgMax) {
					this.realtyPrice = this.stgMax;
				}
				if (this.realtyPrice < this.stgMin) {
					this.realtyPrice = this.stgMin;
				}
				this.updatePrvSlider();
				this.pledgeSlider.set(this.pledge);
				this.getPrvPercent();

				if (this.activeMortgageTabs === 'refin' || this.activeMortgageTabs === 'pledge') {
					this.loanSlider.set(this.loanAmount)

					if (this.realtyPrice === this.stgMin) {
						this.$refs.loanInput.setAttribute('disabled', 'disabled');
						this.$refs.mortgageLoan.setAttribute('disabled', 'disabled');
					}
					else {
						if (this.$refs.loanInput.getAttribute('disabled') === 'disabled' && this.$refs.mortgageLoan.getAttribute('disabled') === 'disabled') {
							this.$refs.loanInput.removeAttribute('disabled');
							this.$refs.mortgageLoan.removeAttribute('disabled');
						}
					}
					this.checkLoanAmount();
				}

				if (this.activeMortgageTabs === 'refin') {
					this.getRefinMaxSum();
				}
				else if (this.activeMortgageTabs === 'pledge') {
					this.getPledgeMaxSum();
				}
				else {
					this.$nextTick(() => {
						this.loanSlider.updateOptions({
							range: {
								'min': this.amountMin,
								'max': this.realtyPrice === this.stgMin ? this.realtyPrice + 1 : this.realtyPrice
							}
						});
					});
				}
			}
		},
		computed: {
			sliderShow() {
				return this.activeMortgageTabs !== 'pledge'
			},
			loanAmountShow() {
				return this.activeMortgageTabs !== 'buy' && this.targetsCode !== 'product_military' && this.targetsCode !== 'product_military_family'
			},
			pledgeShow() {
				return this.activeMortgageTabs !== 'refin' && this.activeMortgageTabs !== 'pledge' && this.targetsCode !== 'product_military' && this.targetsCode !== 'product_military_family'
			},
			periodShow() {
				return this.targetsCode !== 'product_military' && this.targetsCode !== 'product_military_family'
			},
			developersFamilyShow() {
				return this.loanAmount > 500000
			},
			optionsHeight() {
				return {
					'mortgage-calcnew__cards_h-avto': this.optionsCounter <= 4
				}
			},
			calcData() {
				return {
					income: this.income,
					loanAmount: this.loanAmount,
					monthlyPay: this.monthlyPay,
					pledge: this.pledge,
					rate: this.rate,
					realtyPrice: this.realtyPrice,
					matcap: this.matcap,
					period: this.period
				}
			},
			allInfoLk() {
				var buffer = [];
				buffer.push({
					'title': 'Регион',
					'code': 'region',
					'value': this.currentRegion
				});
				if (this.fio) {
					buffer.push({
						'title': 'Имя Фамилия',
						'code': 'name',
						'value': this.fio
					});
				}
				if (this.email) {
					buffer.push({
						'title': 'Email',
						'code': 'email',
						'value': this.email
					});
				}
				if (this.phone) {
					buffer.push({
						'title': 'Телефон',
						'code': 'phone',
						'value': this.phone
					});
				}
				if (this.rate) {
					buffer.push({
						'title': 'Процентная ставка',
						'code': 'percent',
						'value': this.rate
					});
				}
				if (this.monthlyPay) {
					buffer.push({
						'title': 'Ежемесячный платеж',
						'code': 'month_pay',
						'value': this.monthlyPay
					});
				}
				if (this.loanAmount) {
					buffer.push({
						'title': 'Сумма кредита',
						'code': 'sum',
						'value': this.loanAmount
					});
				}
				if (this.inn) {
					buffer.push({
						'title': 'ИНН',
						'code': 'inn',
						'value': this.inn
					});
				}
				if (this.realtyAmount) {
					buffer.push({
						'title': 'Стоимость недвижимости',
						'code': 'build_cost',
						'value': this.realtyAmount
					});
				}
				if (this.period) {
					buffer.push({
						'title': 'Срок кредита',
						'code': 'time',
						'value': this.period
					});
				}
				if (this.byHouse) {
					buffer.push({
						'title': 'Объект',
						'code': 'object',
						'value': 'Жилой дом'
					});
				}
				if (this.targets) {
					buffer.push({
						'title': 'Программа',
						'code': 'target',
						'value': this.targetsCode
					});
				}
				if (this.activeTabs) {
					buffer.push({
						'title': 'Тип ипотеки',
						'code': 'type',
						'value': this.activeTabs === 'bycost' ? 'bycost' : 'byincome'
					});
				}
				if (this.realtyPrice) {
					buffer.push({
						'title': 'Стоимость жилья',
						'code': 'stg_value',
						'value': this.realtyPrice
					});
				}
				if (this.pledge) {
					buffer.push({
						'title': 'Первоначальный взнос',
						'code': 'prv_value',
						'value': this.pledge
					});
				}
				if (this.activeCodes.length > 0) {
					if (this.realty === 'pledged') {
						var serviceOptions = [];
						if (serviceOptions.indexOf('real_estate_pledged') === -1) {
							for (var i = 0; i < this.activeCodes.length; i++) {
								serviceOptions.push(this.activeCodes[i])
							}
							serviceOptions.push('real_estate_pledged');
						}
					}
					buffer.push({
						'title': 'Дополнительные опции',
						'code': 'options',
						'array': this.realty !== 'pledged' ? this.activeCodes : serviceOptions
					});
				}
				if (this.purposeLk) {
					buffer.push({
						'title': 'Цель кредита',
						'code': 'purpose',
						'value': this.purposeLk
					});
				}
				if (this.realtyType) {
					buffer.push({
						'title': 'Тип недвижимости',
						'code': 'realtyType',
						'value': this.realtyType
					});
				}
				if (this.readiness) {
					buffer.push({
						'title': 'Степень готовности',
						'code': 'readiness',
						'value': this.readiness
					});
				}
				if (this.matcap) {
					buffer.push({
						'title': 'Сумма материнского капитала (руб)',
						'code': 'mc_amount',
						'value': this.maternalCapital
					});
				}
				if (this.rebates.length > 0) {
					buffer.push({
						'title': 'Примененные вычеты',
						'code': 'rebates',
						'array': this.rebates
					});
				}
				return buffer;
			}
		},
		watch: {
			activeMortgageTabs(value) {
				switch(value) {
					case 'buy':
						this.purposeLk = 'buying';
						this.slidesProducts = this.slidesProductsBuy;
						break;
					case 'refin':
						this.purposeLk = 'refinancing';
						this.slidesProducts = this.slidesProductsRefin;
						break;
					case 'pledge':
						this.purposeLk = 'pledge';
						break;
				}
			},
			currentRegion() {
				this.checkCurrentRegion();
				this.getDefaultOptions(this.targetsCode);
				if (this.realty === 'machine_building' || this.realty === 'machine_ready') {
					this.getMachineProgram();
				}
			},
			activeOptionsTabs() {
				var _this = this;
				if (this.activeOptionsTabs === 'rate') {
					if (this.activeCodes.length === 0) {
						var newRateOptions = this.targetOptionsFirst.filter(function(val) {return  _this.rateOptions.indexOf(val.code) !== -1 });
						this.targetOptions = newRateOptions;
					}
					else if (this.activeCodes.length === 1) {
						var trueTargets = this.targetOptionsFirst.filter(function(val) { return _this.rateOptions.indexOf(val.code) !== -1 });
						var	firstVal = trueTargets.filter(function(val) {return _this.activeCodes.indexOf(val.code) !== -1 });
						if (firstVal.length === 0) {
							this.targetOptions = trueTargets.filter(function(val) {return _this.targetOptions.indexOf(val) !== -1 });
						}
						else {
							var	optionCode = firstVal[0].options.map(function(val) { return val.code });
							var	optionVal = trueTargets.filter(function(val) { return optionCode.indexOf(val.code) !== -1 });
							var	trueData = trueTargets.filter(function(val) { return val.code === firstVal[0].code });
							this.targetOptions = optionVal;
							this.targetOptions.unshift(trueData[0]);
						}
					}
					else {
						trueTargets = this.targetOptionsFirst.filter(function(val) { return _this.rateOptions.indexOf(val.code) !== -1 });
						firstVal = trueTargets.filter(function(val) { return _this.activeCodes.indexOf(val.code) !== -1 });
						var firstValCode = firstVal.map(function(val) { return val.code });
						if (firstVal.length === 0) {
							this.targetOptions = trueTargets.filter(function(val) {return  _this.targetOptions.indexOf(val) !== -1 });
						}
						else if (firstVal.length === 1) {
							var commonArr = firstVal.map(function(val) {return  val.options });
							optionCode = commonArr[0].map(function(val) {return  val.code });
							optionVal = trueTargets.filter(function(val) {return  optionCode.indexOf(val.code) !== -1 });
							trueData = trueTargets.filter(function(val) { return firstValCode.indexOf(val.code) !== -1 });
							this.targetOptions = optionVal;
							this.targetOptions.unshift(trueData[0]);
						}
						else {
							commonArr = firstVal.map(function(val) {return  val.options });
							for (var i = 0; i < commonArr.length-1; i++) {
								var codeFirst = commonArr[i].map(function(val) { return val.code }),
									codeSecond = commonArr[i+1].map(function(val) { return val.code }),
									codeResult = codeSecond.filter(function (val) { return codeFirst.indexOf(val) !== -1 }),
									newArr = commonArr[i].filter(function(val) { return codeResult.indexOf(val.code) !== -1 });
							}
							optionCode = newArr.map(function(val) { return val.code });
							optionVal = trueTargets.filter(function(val) { return optionCode.indexOf(val.code) !== -1 });
							trueData = trueTargets.filter(function(val) { return firstValCode.indexOf(val.code) !== -1 });
							this.targetOptions = optionVal;
							for (i = 0; i < trueData.length; i++) {
								if (this.targetOptions.indexOf(trueData[i]) === -1) {
									this.targetOptions.unshift(trueData[i]);
								}
							}
						}
					}
				}
				else if (this.activeOptionsTabs === 'action') {
					if (this.activeCodes.length === 0) {
						this.targetOptions = this.targetOptionsFirst.filter(function(val) {return _this.actionOptions.indexOf(val.code) !== -1 });
					}
					else if (this.activeCodes.length === 1) {
						trueTargets = this.targetOptionsFirst.filter(function(val) {return _this.actionOptions.indexOf(val.code) !== -1 });
						firstVal = trueTargets.filter(function(val) {return _this.activeCodes.indexOf(val.code) !== -1 });
						if (firstVal.length === 0) {
							this.targetOptions = trueTargets.filter(function(val) { return _this.targetOptions.indexOf(val) !== -1 });
						}
						else {
							optionCode = firstVal[0].options.map(function(val) {return val.code });
							optionVal = trueTargets.filter(function(val) { return optionCode.indexOf(val.code) !== -1 });
							trueData = trueTargets.filter(function(val) { return val.code === firstVal[0].code });
							this.targetOptions = optionVal;
							this.targetOptions.unshift(trueData[0]);
						}
					}
					else {
						trueTargets = this.targetOptionsFirst.filter(function(val) {return _this.actionOptions.indexOf(val.code) !== -1 });
						firstVal = trueTargets.filter(function(val) { return _this.activeCodes.indexOf(val.code) !== -1 });
						firstValCode = firstVal.map(function(val) {return val.code });
						if (firstVal.length === 0) {
							this.targetOptions = trueTargets.filter(function(val) { return _this.targetOptions.indexOf(val) !== -1 });
						}
						else if (firstVal.length === 1) {
							commonArr = firstVal.map(function(val) { return val.options });
							optionCode = commonArr[0].map(function(val) { return val.code });
							optionVal = trueTargets.filter(function(val) { return optionCode.indexOf(val.code) !== -1 });
							trueData = trueTargets.filter(function(val) { return firstValCode.indexOf(val.code) !== -1 });
							this.targetOptions = optionVal;
							this.targetOptions.unshift(trueData[0]);
						}
						else {
							commonArr = firstVal.map(function(val) { return val.options });
							for (i = 0; i < commonArr.length-1; i++) {
								codeFirst = commonArr[i].map(function(val) { return val.code });
								codeSecond = commonArr[i+1].map(function(val) { return val.code });
								codeResult = codeSecond.filter(function(val) { return codeFirst.indexOf(val) !== -1 });
								newArr = commonArr[i].filter(function(val) { return codeResult.indexOf(val.code) !== -1 });
							}
							optionCode = newArr.map(function(val) {return val.code });
							optionVal = trueTargets.filter(function(val) { return optionCode.indexOf(val.code) !== -1 });
							trueData = trueTargets.filter(function(val) { return firstValCode.indexOf(val.code) !== -1 });
							this.targetOptions = optionVal;
							for (i = 0; i < trueData.length; i++) {
								if (this.targetOptions.indexOf(trueData[i]) === -1) {
									this.targetOptions.unshift(trueData[i]);
								}
							}
						}
					}
				}
				else {
					if (this.activeCodes.length === 0) {
						this.targetOptions = this.targetOptionsFirst;
					}
					else if (this.activeCodes.length === 1) {
						firstVal = this.targetOptionsFirst.filter(function(val) {return _this.activeCodes.indexOf(val.code) !== -1 });
						if (firstVal.length > 0) {
							optionCode = firstVal[0].options.map(function(val) { return val.code });
							optionVal = this.targetOptionsFirst.filter(function(val) { return optionCode.indexOf(val.code) !== -1 });
							trueData = this.targetOptionsFirst.filter(function(val) { return val.code === firstVal[0].code });
							this.targetOptions = optionVal;
							this.targetOptions.unshift(trueData[0]);
						}
					}
					else {
						firstVal = this.targetOptionsFirst.filter(function(val) { return _this.activeCodes.indexOf(val.code) !== -1 });
						firstValCode = firstVal.map(function (val) {return val.code });
						commonArr = firstVal.map(function(val) {return val.options });
						newArr = [];
						for (i = 0; i < commonArr.length-1; i++) {
							codeFirst = commonArr[i].map(function(val) { return val.code });
							codeSecond = commonArr[i+1].map(function(val) { return val.code });
							codeResult = codeSecond.filter(function(val) {return codeFirst.indexOf(val) !== -1 });
							newArr = commonArr[i].filter(function(val) {return codeResult.indexOf(val.code) !== -1 });
						}
						optionCode = newArr.map(function(val) { return val.code });
						optionVal = this.targetOptionsFirst.filter(function(val) { return optionCode.indexOf(val.code) !== -1 });
						trueData = this.targetOptionsFirst.filter(function(val) { return firstValCode.indexOf(val.code) !== -1 });
						this.targetOptions = optionVal;
						for (i = 0; i < trueData.length; i++) {
							if (this.targetOptions.indexOf(trueData[i]) === -1) {
								this.targetOptions.unshift(trueData[i]);
							}
						}
					}
				}
				this.activeCyclon();
			},
			realty(value) {
				if (value === 'product_house' || value === 'product_building_house') {
					this.realtyType = 'house';
				}
				else if (value === 'machine_ready' || value === 'machine_building') {
					this.realtyType = 'parking';
				}
				else {
					this.realtyType = 'flat';
				}
				this.readiness = value === 'product_ready' || value === 'product_house' || value === 'machine_ready' ? 'ready' : 'constructions';
				this.setTargets(value);
			},
			mobile(value) {
				this.setActive(value, 'mortgage-tabs');
			},
			optionsCounter(value) {
				if (value > 4) {
					this.bshow = 'Показать все';
				}
				else {
					this.bshow = 'Скрыть';
				}
			},
			matcap(val) {
				if (val) {
					this.updatePrvSlider();
					this.activeCodes.push('maternal_capital');
				}
				else {
					this.activeCodes = this.activeCodes.filter(val => val !== 'maternal_capital');
				}
			},
			targetsCode(value) {
				this.slidesProducts = this.activeMortgageTabs !== 'refin' ? this.slidesProductsBuy.filter(val => !val.exceptions.includes(value)) : this.slidesProductsRefin.filter(val => !val.exceptions.includes(value));
				this.getDefaultOptions(value);
				this.activeCyclon();
				if (this.developersFlag) {
					this.updatePrvSlider()
				}
			},
			loanAmount() {
				if (this.developersFlag) {
					this.checkDevelopersDfo();
				}
			},
			period() {
				if (this.developersFlag) {
					this.checkDevelopersDfo();
				}
			},
			itIncome(value) {
				this.itIncomeError = value < this.itIncomeMin ? true : false;
			},
			itRegion(value) {
				this.itIncomeMin = value !== 'Другой город' ? 150000 : 100000;
			}
		},
		updated() {
			lkStore.developersData = this.allInfoLk;
		},
		beforeMount() {
			this.calculatorPending = true;
			this.developersFlag = this.$props.developers === "Y" ? true : false;
			this.slidesProducts = this.slidesProductsBuy;
			let url = `/rest/v1/mortgage/products?sort=code&where[code]=${this.productsActual.join(',')}`;
			this.getRegionsList();
			axios.get(url, {headers: {'Accept': 'application/vnd.api+json'}})
				.then((response) => {
					this.apix = response.data.data;
					this.getActualProducts();
					if (this.$props.izs !== 'Y') {
						this.getApixValues('product_building');
					}
					if (this.$props.izs === 'Y') {
						this.getApixValues('product_house');
						this.slidesProducts[2].exceptions = ['product_house', 'product_building_house'];
					}
					this.checkCurrentRegion();
					this.getRealtyApixNames();
					this.getCalculationsFunctions();
					this.createSliders();
					this.getDefaultProgram();
				})
				.finally(() => {
					this.calculatorReady = true;
					this.calculatorPending = false;
				})

				this.hiddenOptions.push('mchs_discount')
		},
		mounted() {
			this.realty = this.$props.izs === 'Y' ? 'product_house' : 'product_building';
			this.developersDi = this.developersFlag && getQueryParameterByName('partner') === 'fastapprove_di' ? true : false;
            this.$modal.show('paymentsShedule');
		}
	}
</script>
<style lang="scss">
@import '/local/templates/redesign/src/assets/scss/block/mortgage-calculator.scss';

.mortgage-calcnew {
	& .noUi-horizontal .noUi-handle {
        background-image: none;
        border: 4px solid var(--deposits-calculator-accent, #{$green-223});
        border-radius: 50%;
        background: $white-101;
        @include fluid('width', 16px);
        @include fluid('height', 16px);
    }
}
</style>
